module.exports = __webpack_public_path__ + "img/girlModal.a2b1906f.svg";